import React from 'react';
import { useTranslation } from 'react-i18next';
import { useModalState } from '@qapline/helpers';

import { ColumnsIcon } from '../../../../assets';
import { Button } from '../../../Button';
import { Tooltip } from '../../../Tooltip';
import { TableColumnSettingsModal } from './TableColumnSettingsModal';

export const TableColumnSettingsButton: React.FC = () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'table.columnSettings' });
    const { isOpen, openModal, closeModal } = useModalState();

    return (
        <>
            <Tooltip content={t('title')}>
                <Button aria-label={t('title')} color="light" onClick={openModal} variant="fab">
                    <ColumnsIcon height={20} width={20} />
                </Button>
            </Tooltip>
            {isOpen && <TableColumnSettingsModal onClose={closeModal} />}
        </>
    );
};
